import update from 'immutability-helper';
import moment from 'moment';
// import orderApi from '../lib/api/order';
import { addErrors, clearErrors } from './eventPageReducer';
import { clearTicketAddressErrors, setTicketAddressErrors } from './ticketAddressReducer';
import { createShoppingCart } from './shoppingCartReducer';
import { next, startLoading } from "./checkoutProcessReducer";
import shoppingCartApi from '../lib/api/shoppingCart';
import paymentApi from "../lib/api/payment";
import history from '../lib/history';
import fbPixelService from '../lib/fbPixel-service';

// ----
// Helper
//----
function checkMandatory(obj, fields) {
	return fields.map(field => {
		if (!obj[field] || obj[field].length <= 0) {
			return field + "_required";
		}
		return null;
	}).filter(el => el);
}

function checkEmailFormat(email) {
	// check format of email to be like: "someSigns@someSigns.someSigns"
	if (email.length > 0) {
		return /\S+@\S+\.\S+/.test(email);
	}
	return true;
}

/* NOT IN USE function checkPaymentTypeExpired(paymentType, bookingOffice, eventBegin) {
	const availabilityInHours = bookingOffice
		.paymentTypeAvailabilityInHours[paymentType] || 0;
	const availableUntil = moment(eventBegin).subtract(availabilityInHours, 'hours');
	const expired = moment() > availableUntil;
	return expired;
}
*/
function checkShipmentTypeExpired(shipmentType, bookingOffice, eventBegin) {
	const shipmentAvailabilityInHours = bookingOffice
		.shipmentTypeAvailabilityInHours[shipmentType] || 0;
	const shipmentAvailableUntil = moment(eventBegin)
		.subtract(shipmentAvailabilityInHours, 'hours');
	return moment() > shipmentAvailableUntil;
}

function sanitizeEmptyStrings(obj, fieldsToSanitize) {
	if (!obj || typeof obj !== 'object') {
		return obj;
	}
	let hasChanges = false;
	const cleanObj = Array.isArray(obj) ? [...obj] : { ...obj };
	const fields = fieldsToSanitize || Object.keys(obj);

	fields.forEach(field => {
		if (Object.prototype.hasOwnProperty.call(obj, field)) {
			if (cleanObj[field] === '') {
				cleanObj[field] = null;
				hasChanges = true;
			}
		}
	});
	return hasChanges ? cleanObj : obj;
}

function createTicketAddressesDto(ticketAddressData) {
	const ticketAddressesDto = {};
	if (!ticketAddressData) {
		return {};
	}
	Object.entries(ticketAddressData).forEach(([ticketItemUuid, data]) => {
		ticketAddressesDto[ticketItemUuid] = sanitizeEmptyStrings(data.address, ['customSalutation']);
	});
	return ticketAddressesDto;
}

// ------------------------------------
// Constants
// ------------------------------------
export const SET_ORDER = 'ORDER/SET_ORDER';
export const TOGGLE_LOADING = 'ORDER/TOGGLE_LOADING';

/* NOT IN USE export function setOrder(eventUUID, order) {
	return {
		type: SET_ORDER,
		eventUUID,
		order,
	};
}
*/

// ------------------------------------
// Action Creator
// ------------------------------------
function toggleLoading() {
	return {
		type: TOGGLE_LOADING,
	};
}

//-------------------------------------
// Helper Functions
//-------------------------------------

function getEventPathPartIfPresent(eventUuid) {
	if (!eventUuid) {
		return '';
	}
	return `${eventUuid}/`;
}

export function validateOrderData(eventUUID, selectedShipmentType) {
	return async (dispatch, getState) => {
		try {
			dispatch(clearErrors());
			dispatch(clearTicketAddressErrors());
			const state = getState();
			const merchantId = state.merchant.merchantId;
			const ticketAddressData = state.ticketAddress.data;
			const ticketAddressAdditionalInfoMandatory = state.ticketAddress.ticketAddressAdditionalDropDownMandatory;
			const showCustomerAddressAdditionalInfo = state.customer.showCustomerAddressAdditionalDropDown;
			const customerAddressAdditionalInfoMandatory = state.customer.customerAddressAdditionalDropDownMandatory;
			const ticketAddressFunctionMandatory = state.ticketAddress.ticketAddressFunctionDropDownMandatory;
			const showLegalAddressAdditionalDropDown = state.customer.showLegalAddressAdditionalDropDown;
			const orderComment = state.checkoutPage.orderComment

			dispatch(toggleLoading());
			const expiredDto = await shoppingCartApi.hasTimeExpired(state.shoppingCart.elements[merchantId].expirationTime);
			dispatch(toggleLoading());
			if (expiredDto.expired) {
				dispatch(createShoppingCart());
				history.push(`${getEventPathPartIfPresent(eventUUID)}shoppingcart-expired`);
				return;
			}
			const shippingMandatoryFields = ['lastname', 'phoneNumber',
				'email', 'postalCode', 'city', 'street', 'houseNumber'];
			const billingMandatoryFields = ['lastname', 'phoneNumber',
				'email', 'postalCode', 'city', 'street', 'houseNumber'];
			if (showCustomerAddressAdditionalInfo && customerAddressAdditionalInfoMandatory) {
				shippingMandatoryFields.push('additionalInfo');
				if (showLegalAddressAdditionalDropDown) {
					billingMandatoryFields.push('additionalInfo');
				}
			}
			const shippingErrors = checkMandatory(state.customer.shipmentAddress, shippingMandatoryFields);
			if (!checkEmailFormat(state.customer.shipmentAddress.email)) {
				shippingErrors.push('email_format');
			}
			let billingErrors = [];
			if (state.customer.addressesDiffer) {
				billingErrors = checkMandatory(state.customer.legalAddress, billingMandatoryFields);
				if (!checkEmailFormat(state.customer.legalAddress.email)) {
					billingErrors.push('email_format');
				}
			}

			const ticketAddressElements = Object.keys(ticketAddressData).map(key => ticketAddressData[key]);
			const ticketAddressErrors = {};
			// Validate ticketAddress forms if there are any.
			if (ticketAddressElements.length > 0) {
				const ticketAddressMandatoryFields = ['firstname', 'lastname', 'phoneNumber',
					'postalCode', 'city', 'street', 'houseNumber'];
				if (ticketAddressAdditionalInfoMandatory) {
					ticketAddressMandatoryFields.push('additionalInfo');
				}
				if (ticketAddressFunctionMandatory) {
					ticketAddressMandatoryFields.push('function');
				}

				for (const ticketAddressElement of ticketAddressElements) {
					const errors = checkMandatory(ticketAddressElement.address, ticketAddressMandatoryFields);
					if (!checkEmailFormat(ticketAddressElement.address.email)) {
						errors.push('emailFormat');
					}
					if (errors.length > 0) {
						ticketAddressErrors[ticketAddressElement.displayTicket.ticketItemUuid] = errors;
					}
				}
			}

			let noTicketsError = ['noTicketsSelected'];
			const displayShoppingCartEvents = state.shoppingCart.elements[merchantId].events;
			const displayTickets = displayShoppingCartEvents && displayShoppingCartEvents[0].displayTickets;
			if (displayTickets && displayTickets.length > 0) {
				noTicketsError = [];
			}

			const shoppingCart = state.shoppingCart.elements[state.merchant.merchantId] || { events: [] };
			const minEventBegin = shoppingCart.events.length < 1 ? '' : shoppingCart.events
				.map(scEvent => scEvent.eventBegin)
				.reduce((a, b) => (moment(a) < moment(b) ? a : b));

			const shipmentTypeErrors = selectedShipmentType ? [] : ['noShipmentTypeSelected'];
			if (shipmentTypeErrors.indexOf('noShipmentTypeSelected') === -1
				&& checkShipmentTypeExpired(selectedShipmentType, state.bookingOffice, minEventBegin)) {
				shipmentTypeErrors.push('shipmenTypeExpired');
			}

			let anyError = false;

			if (Object.keys(ticketAddressErrors).length > 0) {
				anyError = true;
				dispatch(setTicketAddressErrors(ticketAddressErrors));
			}

			let invalidCommentError = [];
			if(!orderComment.match(/^[\s\u0020-\u007E\u00A0-\u00FF€]{0,2000}$/)) {
				anyError = true;
				invalidCommentError.push('order_comment_invalid');
			}

			if (shippingErrors.length > 0 || billingErrors.length > 0 || noTicketsError.length > 0
			|| shipmentTypeErrors.length > 0 || invalidCommentError.length > 0) {
				anyError = true;
				dispatch(addErrors([
					...(shipmentTypeErrors.map(it => `shipmenttype_${it}`)),
					/*...(paymentTypeErrors.map(it => `paymenttype_${it}`)),*/
					...noTicketsError,
					...invalidCommentError,
					...(shippingErrors.map(it => `shipment_${it}`)),
					...(billingErrors.map(it => `legal_${it}`)),
				]));
			}

			if (!anyError) {
				if (state.addon.fbPixelId) {
					fbPixelService.trackPurchaseOrCheckout(shoppingCart, 'InitiateCheckout');
				}
				const payloadInitCheckout = {
					input: {
						shoppingCartSecureId: shoppingCart.secureId,
						merchantId: merchantId,
						bookingOfficeUuid:  getState().bookingOffice.uuid,
						pcuiUrl: window.location.origin,
						customer: {
							shipmentAddress:  sanitizeEmptyStrings(getState().customer.shipmentAddress, ['customSalutation']),
							legalAddress:  sanitizeEmptyStrings(getState().customer.legalAddress, ['customSalutation']),
							addressesDiffer: getState().customer.addressesDiffer,
						},
						ticketAddresses: createTicketAddressesDto(getState().ticketAddress.data),
						selectedShipmentType: selectedShipmentType,
						selectedEventUuid: getState().event.selected,
						plUuidCodeMap: getState().accessCodes.plUuidCodeMap,
						sponsorCodes: getState().sponsorCodes.sponsorCodes,
						comment: orderComment,
					},
					history: getState().checkout.checkoutHistory
				}
				dispatch(startLoading());
				const checkoutState = await paymentApi.next(payloadInitCheckout, getState().merchant)
				dispatch(next(checkoutState));
				history.push(`${getEventPathPartIfPresent(eventUUID)}checkout`)
			}
		} catch (e) {
			console.info('Error occured in validate OrderData: ', e);
			history.push(`${getEventPathPartIfPresent(eventUUID)}unknown-error`);
			await Promise.reject();
		}
	};
}

// Variant for Paypal Plus
//let lastPlaceOrderV2 = null;
/* export function placeOrderV2(ppp) {
	const now = +new Date();

	if (lastPlaceOrderV2 && (now - lastPlaceOrderV2 < 0)) {
		console.info('debounced place order... doing nothing');
		return async () => { };
	}
	console.info('PLACE_ORDER_V2');

	lastPlaceOrderV2 = now;
	return async(dispatch, getState) => {
		const state = getState();
		const merchantId = state.merchant.merchantId;
		const eventUuid = state.event.selected;
		try {
			dispatch(toggleLoading());
			const expiredDto = await shoppingCartApi.hasTimeExpired(state.shoppingCart.elements[merchantId].expirationTime);
			if (expiredDto.expired) {
				history.push(`/${getEventPathPartIfPresent(eventUuid)}shoppingcart-expired`);
				return;
			}
		} catch (e) {
			dispatch(toggleLoading());
			console.error('Error occured in expiry check of placeOrderV2: ', e);
			history.push(`/${getEventPathPartIfPresent(eventUuid)}unknown-error`);
			Promise.reject();
			throw e;
		}
		try {
			/* if paymentType == null, paymentType='PAYPAL_PLUS'
			Reason: There is no way for checking whether PayPal has been selected in the iFrame if defaultPaymentType = zero and PayPal.
			was selected by the user.
			The store is not updated because we don't get any feedback from the PPP if a PPP payment method has been selected. */
/*
			const paymentType = getState().checkoutPage.selectedPaymentType || 'PAYPAL_PLUS';
			const orderCreationDTO = {
				shippingAddress: getState().customer.shipmentAddress,
				billingAddress: getState().customer.legalAddress,
				paymentType,
				shipmentType: getState().checkoutPage.selectedShipmentType,
				shoppingCartId: getState().shoppingCart.elements[merchantId].secureId,
				ticketAddresses: createTicketAddressesDto(getState().ticketAddress.data),
			};
			// If there are accessCodes in the state, add them to the orderDTO
			const plUuidCodeMap = getState().accessCodes.plUuidCodeMap;
			if (plUuidCodeMap && Object.keys(plUuidCodeMap).length > 0) {
				orderCreationDTO.plUuidCodeMap = plUuidCodeMap;
			}
			// If there are sponsor Codes in the state, add them to the orderDTO
			// const sponsorCodes = getState().sponsorCodes.sponsorCodes;
			//if (sponsorCodes && sponsorCodes.length > 0) {
			//	orderCreationDTO.sponsorCodes = sponsorCodes;
			//}

			const checkoutSuccessPath = `${getEventPathPartIfPresent(eventUuid)}purchase-success`;
			const response = await orderApi.placeOrderV2(
				checkoutSuccessPath,
				merchantId,
				getState().merchant.themeName,
				orderCreationDTO,
			);
			if (state.addon.fbPixelId) {
				fbPixelService.trackPurchaseOrCheckout(state.shoppingCart.elements[merchantId], 'Purchase');
			}
			if (response.doPaymentRedirect) {
				ppp.doCheckout();
			} else {
				window.location.href = response.redirectUrl;
			}
		} catch (e) {
			console.error('ERROR: ', e);
			dispatch(refreshShoppingCart(merchantId, getState().shoppingCart.elements[merchantId]));
			dispatch(toggleLoading());
			history.push(`/${getEventPathPartIfPresent(eventUuid)}order-error`);
			Promise.reject('Error on placing order');
		}
	};
}

let lastPlaceOrder = null;*/
/*export function placeOrder(eventUUID, merchantId, selectedShipmentType, selectedPaymentType) {
	const now = +new Date();

	if (lastPlaceOrder && (now - lastPlaceOrder < 30000)) {
		console.info('debounced place order... doing nothing');
		return async () => { };
	}
	console.info('PLACE_ORDER');

	lastPlaceOrder = now;
	return async (dispatch, getState) => {
		try {
			dispatch(toggleLoading());
			const orderCreationDTO = {
				shippingAddress: getState().customer.shipmentAddress,
				billingAddress: getState().customer.legalAddress,
				paymentType: selectedPaymentType,
				shipmentType: selectedShipmentType,
				shoppingCartId: getState().shoppingCart.elements[merchantId].secureId,
				ticketAddresses: createTicketAddressesDto(getState().ticketAddress.data),
			};
			const checkoutSuccessPath = `${getEventPathPartIfPresent(eventUUID)}purchase-success`;
			const response = await orderApi.placeOrder(
				checkoutSuccessPath,
				merchantId,
				getState().merchant.themeName,
				orderCreationDTO,
			);
			window.location.href = response.redirectUrl;
		} catch (e) {
			console.error('ERROR: ', e);
			dispatch(refreshShoppingCart(merchantId, getState().shoppingCart.elements[merchantId]));
			dispatch(toggleLoading());
			history.push(`/${getEventPathPartIfPresent(eventUUID)}order-error`);
		}
		return Promise.resolve();
	};
}*/
/*
export function validateAndPlaceOrder(eventUUID, selectedShipmentType, selectedPaymentType) {
	return async (dispatch, getState) => {
		dispatch(clearErrors());
		dispatch(clearTicketAddressErrors());
		const state = getState();
		const merchantId = state.merchant.merchantId;
		const ticketAddressData = state.ticketAddress.data;
		const ticketAddressAdditionalInfoMandatory = state.ticketAddress.ticketAddressAdditionalDropDownMandatory;
		const ticketAddressFunctionMandatory = state.ticketAddress.ticketAddressFunctionDropDownMandatory;

		dispatch(toggleLoading());
		const expiredDto = await shoppingCartApi.hasTimeExpired(state.shoppingCart.elements[merchantId].expirationTime);
		dispatch(toggleLoading());
		if (expiredDto.expired) {
			dispatch(createShoppingCart());
			history.push(`/${getEventPathPartIfPresent(eventUUID)}shoppingcart-expired`);
			return;
		}
		const addressMandatoryFields = ['lastname', 'phoneNumber',
			'email', 'postalCode', 'city', 'street', 'houseNumber'];
		const shippingErrors = checkMandatory(state.customer.shipmentAddress, addressMandatoryFields);
		if (!checkEmailFormat(state.customer.shipmentAddress.email)) {
			shippingErrors.push('emailFormat');
		}
		let billingErrors = [];
		if (state.customer.addressesDiffer) {
			billingErrors = checkMandatory(state.customer.legalAddress, addressMandatoryFields);
			if (!checkEmailFormat(state.customer.legalAddress.email)) {
				billingErrors.push('emailFormat');
			}
		}

		const ticketAddressMandatoryFields = ['firstname', 'lastname', 'phoneNumber',
			'postalCode', 'city', 'street', 'houseNumber'];
		if (ticketAddressAdditionalInfoMandatory) {
			ticketAddressMandatoryFields.push('additionalInfo');
		}
		if (ticketAddressFunctionMandatory) {
			ticketAddressMandatoryFields.push('function');
		}
		const ticketAddressErrors = {};
		const ticketAddressElements = Object.keys(ticketAddressData).map(key => ticketAddressData[key]);
		for (const ticketAddressElement of ticketAddressElements) {
			const errors = checkMandatory(ticketAddressElement.address, ticketAddressMandatoryFields);
			if (errors.length > 0) {
				ticketAddressErrors[ticketAddressElement.displayTicket.ticketItemUuid] = errors;
			}
			if (!checkEmailFormat(ticketAddressElement.address.email)) {
				ticketAddressErrors[ticketAddressElement.displayTicket.ticketItemUuid].push('emailFormat');
			}
		}

		let noTicketsError = ['noTicketsSelected'];
		const displayShoppingCartEvents = state.shoppingCart.elements[merchantId].events;
		const displayTickets = displayShoppingCartEvents && displayShoppingCartEvents[0].displayTickets;
		if (displayTickets && displayTickets.length > 0) {
			noTicketsError = [];
		}
		const paymentTypeErrors = selectedPaymentType ? [] : ['noPaymentTypeSelected'];
		const shoppingCart = state.shoppingCart.elements[state.merchant.merchantId] || { events: [] };
		const minEventBegin = shoppingCart.events.length < 1 ? '' : shoppingCart.events
		.map(scEvent => scEvent.eventBegin)
		.reduce((a, b) => (moment(a) < moment(b) ? a : b));

		if (paymentTypeErrors.indexOf('noPaymentTypeSelected') === -1
			&& checkPaymentTypeExpired(selectedPaymentType, state.bookingOffice, minEventBegin)) {
			paymentTypeErrors.push('paymentTypeExpired');
		}

		const shipmentTypeErrors = selectedShipmentType ? [] : ['noShipmentTypeSelected'];
		if (shipmentTypeErrors.indexOf('noShipmentTypeSelected') === -1
			&& checkShipmentTypeExpired(selectedShipmentType, state.bookingOffice, minEventBegin)) {
			shipmentTypeErrors.push('shipmenTypeExpired');
		}

		let anyError = false;

		if (Object.keys(ticketAddressErrors).length > 0) {
			anyError = true;
			dispatch(setTicketAddressErrors(ticketAddressErrors));
		}

		if (shippingErrors.length > 0 || billingErrors.length > 0 || noTicketsError.length > 0
		|| shipmentTypeErrors.length > 0 || paymentTypeErrors.length > 0) {
			anyError = true;
			dispatch(addErrors([
				...(shipmentTypeErrors.map(it => `shipmenttype_${it}`)),
				...(paymentTypeErrors.map(it => `paymenttype_${it}`)),
				...noTicketsError,
				...(shippingErrors.map(it => `shipment_${it}`)),
				...(billingErrors.map(it => `legal_${it}`)),
			]));
		}

		if (!anyError) {
			dispatch(placeOrder(eventUUID, merchantId, selectedShipmentType, selectedPaymentType));
		}
	};
}*/

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[SET_ORDER]: (state, action) => update(state, {
		elements: {
			[action.eventUUID]: { $set: action.order },
		},
	}),
	[TOGGLE_LOADING]: (state) => update(state, {
		isLoading: { $set: !state.isLoading },
	}),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
	elements: {},
	isLoading: false,
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
